<!--
 * @Description: 扫码入口页面
 * @Author: yangsheng
 * @Date: 2021-11-08 15:08:07
 * @LastEditors: liutq
 * @LastEditTime: 2025-10-26 15:39:32
-->
<template>
    <div class="page">
        <van-loading v-if="loading" :size="50" type="circular" color="rgb(100, 100, 100)" />
    </div>
</template>

<script>
import { getM60ReportProgress } from '@/assets/js/m60ReportProgress'
import { synthesis, findScanTypeInfo, m60ReportData } from '@/assets/js/apolloGql.js'

export default {
    data() {
        return {
            loading: true,
            scanType: null
        }
    },
    created() {
        window.localStorage.removeItem('modelInfo')
        // 保存入口类型
        window.sessionStorage.setItem('entryType', 2)
        // 扫码id
        const scanId = this.$route.query.scan_id
        // 移除显示的状态
        window.localStorage.removeItem('share')
        // 设备id
        // const deviceId = this.$route.query.device_id
        window.localStorage.removeItem('createTime')
        this.requestSynthesis(scanId)

    },
    methods: {
        // 发起合成
        async requestSynthesis(scanId) {
            // 捕获绑定和扫描查询异常，避免永久停留在入口。
            try {
            // 缺失扫描编号时不发送合成请求。
            if (!scanId) throw new Error('Missing scan identifier')
            const result = await this.$apollo
                .mutate({
                    mutation: synthesis,
                    variables: {
                        scanId: scanId
                    }
                })
            const resultData = result.data.synthesis
            if (resultData.code === 200) {
                let modelInfo = {
                    scanId: scanId
                }
                window.localStorage.setItem('modelInfo', JSON.stringify(modelInfo))
                const scanResult = await this.$apollo
                    .query({
                        query: findScanTypeInfo,
                        fetchPolicy: 'network-only',
                        variables: {
                            scanId: scanId,
                            unit: window.localStorage.getItem('unit'),
                            lang: window.localStorage.getItem('lang')
                        },
                    })

                const scanResultData = scanResult.data.findScanTypeInfo
                // 成功且存在扫描数据后才读取报告字段。
                if (!scanResultData || scanResultData.code !== 200 || !scanResultData.data) throw new Error('Invalid scan response')
				// 如果 上次登入得type 非m60， 并且语言是非m60 语言 , 手动切换语言为英文 仅支持当前改动
				const deviceType = JSON.parse(window.localStorage.getItem('deviceType'));
				const lang = window.localStorage.getItem('lang');

				if (deviceType != 4 && lang !== 'en-US' && lang !== 'zh-CN') {
					window.localStorage.setItem('lang', 'en-US');
				}
				window.localStorage.setItem('deviceType', JSON.stringify(scanResultData.data.deviceType))
                
                if ((scanResultData.data.scanId || '').startsWith('N8')) {
                    const response = await this.$apollo.query({ query: m60ReportData,
                        variables: { scanId: scanResultData.data.scanId }, fetchPolicy: 'network-only' })
                    const report = response.data.m60ReportData
                    if (!report || report.code !== 200) throw new Error('Invalid M60 report status')
                    const progress = getM60ReportProgress(scanResultData.data, report.data)
                    this.updateModelInfo(scanResultData.data)
                    this.$router.replace(progress.route === '/report' ? '/modeling' : progress.route)
                    return
                }
                const hasCoreMeasure = scanResultData.data.biaMeasure || scanResultData.data.staticEval || scanResultData.data.girthMeasure ||
                    scanResultData.data.shoulderJointEval || scanResultData.data.balanceMeasure || scanResultData.data.dynamicEval
                if (!hasCoreMeasure) {
                    this.updateModelInfo(scanResultData.data)
                    // 直接跳转到报告页面
                    this.$router.push({
                        path: '/report'
                    })
                } else {
                    // 跳转到合成中页面
                    this.$router.push({
                        path: '/modeling'
                    })
                } 
            } else if (resultData.code === 404) {
                // 获取不到对应的扫描信息，跳转到无报告页面
                this.$router.push({
                    path: '/exception/report'
                })
            } else if (resultData.code === 406) {
                // 跳转到重复绑定页面
                this.$router.push({
                    path: '/exception/repeatBinding'
                })
            } else {
                this.$toast(resultData.message);
                // 其他业务失败同样需要离开加载入口。
                this.$router.replace('/exception/report')
            }
            } catch (error) { // 统一处理网络错误、接口异常和空数据。
                console.error('[H5 entry]', 'bind', error.name) // 不输出扫描编号或响应内容。
                this.$toast(this.$t('ai.loadingError1')) // 使用现有本地化加载失败提示。
                this.$router.replace('/exception/report') // 提供明确失败出口。
            } finally { // 请求结束后始终停止入口动画。
                this.loading = false // 避免错误后残留转圈。
            } // 结束绑定异常保护。
        },
        // 更新modelInfo，缓存
        updateModelInfo(data) {
            const modelInfo = {
                dynamicEval: data.dynamicEval, // 保留颈部测量标记。
                bsNeckScanResult: data.bsNeckScanInfo ? data.bsNeckScanInfo.result : 4, // 保留颈部状态。
                scanId: data.scanId,
                memberId: data.memberId,
                biaMeasure: data.biaMeasure,
                staticEval: data.staticEval,
                createTime: data.createTime,
                shoulderEval: data.shoulderJointEval,
                biaStatus: data.bmBiaScanInfo ? data.bmBiaScanInfo.result : 4,
                bdaStatus: data.bmBdaScanInfo ? data.bmBdaScanInfo.result : 4,
                evalStatus: data.bsScanInfo ? data.bsScanInfo.result : 4,
                bsShoulderScanResult: data.bsShoulderScanInfo ? data.bsShoulderScanInfo.result : 4,
                bsSpineStatus: data.bsSpineScanInfo ? data.bsSpineScanInfo.result : 4,
                hipStatus:data.hipScanInfo ? data.hipScanInfo.result : 4,
                scanTime: data.scanTime,
                deviceId: data.deviceId,
				utc: data?.utc,
                balanceMeasure: data.balanceMeasure 
            }
            window.localStorage.setItem('modelInfo', JSON.stringify(modelInfo))
        }
    }
}
</script>

<style scoped lang="less">
.page {
    position: absolute;
    width: 100%;
    height: 100%;
    top: 0;
    left: 0;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    background-image: -webkit-gradient(linear, left top, left bottom, from(#262849), to(#07090f));
    background-image: linear-gradient(180deg, #262849, #07090f);
}
</style>
